import React, { memo } from 'react';

import SeoTextsBlocks from 'components/SeoTextsBlocks';
import SeoMetaTextBlock from 'components/SeoMetaTextBlock';
import { BanksPageBreadCrumbs } from 'components/BanksPageBreadCrumbs';

import { BreadCrumbsWrapper } from 'components/FooterStyles';

import { Wrapper } from './styles';

const BanksPageFooter = memo(() => (
  <Wrapper>
    <SeoMetaTextBlock />
    <SeoTextsBlocks />

    <BreadCrumbsWrapper>
      <BanksPageBreadCrumbs />
    </BreadCrumbsWrapper>
  </Wrapper>
));

export default BanksPageFooter;
